export type FirebaseEnvConfig = {
  apiKey: string;
  authDomain: string;
  databaseURL: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId: string;
};

export type PortalEnvConfig = {
  apiBaseUrl: string;
  feedFeatureApiBaseUrl: string;
  organizationName: string;
  defaultOrganizationLogo: string;
  firebase: FirebaseEnvConfig;
  vapidKey: string;
  turboverse: {
    baseUrl: string;
    socketUrl: string;
  };
  stomp: {
    sendMessagePath: string;
    heartbeatPath: string;
  };
};

const required = (key: string): string => {
  const value = process.env[key];
  if (!value) {
    throw new Error(
      `Missing ${key}. Add it to Portal/.env (see Portal/.env.example).`
    );
  }
  return value;
};

const optional = (key: string, fallback = ''): string => process.env[key] ?? fallback;

/** Single entry point for all React environment-backed settings. */
export const getPortalEnv = (): PortalEnvConfig => ({
  apiBaseUrl: required('REACT_APP_API_BASE_URL'),
  feedFeatureApiBaseUrl: required('REACT_APP_FEED_FEATURE_API_BASE_URL'),
  organizationName: optional('REACT_APP_ORGANIZATION_NAME', 'KIS'),
  defaultOrganizationLogo: required('REACT_APP_ORG_LOGO_URL'),
  firebase: {
    apiKey: required('REACT_APP_FIREBASE_API_KEY'),
    authDomain: required('REACT_APP_FIREBASE_AUTH_DOMAIN'),
    databaseURL: required('REACT_APP_FIREBASE_DATABASE_URL'),
    projectId: required('REACT_APP_FIREBASE_PROJECT_ID'),
    storageBucket: required('REACT_APP_FIREBASE_STORAGE_BUCKET'),
    messagingSenderId: required('REACT_APP_FIREBASE_MESSAGING_SENDER_ID'),
    appId: required('REACT_APP_FIREBASE_APP_ID'),
    measurementId: optional('REACT_APP_FIREBASE_MEASUREMENT_ID'),
  },
  vapidKey: required('REACT_APP_FIREBASE_VAPID_KEY'),
  turboverse: {
    baseUrl: required('REACT_APP_TURBOVERSE_BASE_URL'),
    socketUrl: required('REACT_APP_TURBOVERSE_SOCKET_URL'),
  },
  stomp: {
    sendMessagePath: optional('REACT_APP_STOMP_SEND_MESSAGE_PATH', '/app/sendMessage'),
    heartbeatPath: optional('REACT_APP_STOMP_HEARTBEAT_PATH', '/heartbeat'),
  },
});

/** Cached config for modules that import static values. */
export const portalEnv = getPortalEnv();
